import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <span className="hw-pulse-dot" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!user.role) {
    return <Navigate to="/onboarding" replace />;
  }
  // Pending partners are strictly locked to the onboarding page — no dashboard,
  // no rooms, no leads until an admin approves them.
  if (user.role === "hotel_partner_pending" && location.pathname !== "/partner/onboarding") {
    return <Navigate to="/partner/onboarding" replace />;
  }
  if (roles && roles.length && !roles.includes(user.role)) {
    // Iter48 — Staff users (role=hotel_partner_staff) inherit access to all
    // partner-only routes. The backend does the fine-grained check per-endpoint.
    if (user.role === "hotel_partner_staff" && roles.includes("hotel_partner")) {
      return children;
    }
    return <Navigate to="/" replace />;
  }
  return children;
}
